import { jsxs as H, jsx as m } from "react/jsx-runtime";
import { c as B } from "./index-65016bfa.mjs";
import { forwardRef as J, useRef as K } from "react";
import { styled as I, css as W } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as X } from "./useQuantum-50e8fd44.mjs";
import { b as Y } from "./Aria-f5e019e2.mjs";
import "./isClient-ec947a14.mjs";
import { c as Z } from "./combineRefs-90f27925.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Icon as $ } from "./icon.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
const z = I.button`
  &.ButtonV1 {
    ${({
  theme: {
    components: { buttonV1: a }
  }
}) => W(a.Button)};
  }
`, N = I.div`
  &.ButtonV1__icon-wrapper {
    ${({
  theme: {
    components: { buttonV1: a }
  }
}) => W(a.IconWrapper)};
  }
`, s = ({
  disabled: a,
  accessibilityOptions: x,
  size: f = "medium",
  type: u = "default",
  color: R = ["default", "danger", "black", "onColor"].includes(u) ? u : "default",
  variant: v = "primary",
  linkProps: t,
  as: y = "button",
  renderAs: n = y,
  onClick: c,
  children: E,
  fullWidth: L,
  active: j,
  iconProps: e,
  leftIcon: r = (e == null ? void 0 : e.leftIconName) || (e == null ? void 0 : e.leftIcon),
  rightIcon: h = (e == null ? void 0 : e.rightIconName) || (e == null ? void 0 : e.rightIcon),
  dataTestId: A,
  className: D,
  ...q
}, M) => {
  var b, o, g;
  const O = X({ label: "Button V1" }), Q = K(null), S = Y(n === "button" ? "button" : "link", { ...x, ariaDisabled: a });
  function T(w) {
    if (a)
      return w.preventDefault();
    c == null || c(w);
  }
  const V = typeof r == "string" ? /* @__PURE__ */ m($, { name: r }) : r, d = typeof h == "string" ? /* @__PURE__ */ m($, { name: h }) : h, _ = ((b = t == null ? void 0 : t.href) == null ? void 0 : b.startsWith("http")) || ((o = t == null ? void 0 : t.href) == null ? void 0 : o.startsWith("#")), U = ((g = t == null ? void 0 : t.href) == null ? void 0 : g.charAt(0)) !== "/", C = (t == null ? void 0 : t.target) ?? (_ || U ? "_blank" : "_self"), F = { href: t == null ? void 0 : t.href, rel: t == null ? void 0 : t.rel, target: C }, G = { as: n, to: t == null ? void 0 : t.href };
  return /* @__PURE__ */ H(
    z,
    {
      ...S,
      ...q,
      type: ["button", "reset", "submit"].includes(u) ? u : "button",
      "data-testid": A,
      ref: Z(Q, M),
      onClick: T,
      className: B("ButtonV1", `ButtonV1--${f}`, `ButtonV1--${R}`, `ButtonV1--${v}`, D, {
        "ButtonV1--fullWidth": L,
        "ButtonV1--disabled": a,
        "ButtonV1--underlined": t == null ? void 0 : t.isAnchorUnderlined,
        "ButtonV1--active": j
      }),
      as: n,
      disabled: a,
      ...!(t != null && t.isCurrentPage) && F,
      ...!_ && G,
      ...O,
      children: [
        V && /* @__PURE__ */ m(N, { className: B("ButtonV1__icon-wrapper", "ButtonV1__icon-wrapper--left", `ButtonV1__icon-wrapper--${f}`), children: V }),
        E,
        d && /* @__PURE__ */ m(N, { className: B("ButtonV1__icon-wrapper", "ButtonV1__icon-wrapper--right", `ButtonV1__icon-wrapper--${f}`), children: d })
      ]
    }
  );
}, rt = J(s);
export {
  rt as ButtonV1
};
